import {addMonthsISO, toISODate} from "../Statistics/format.js";

export {
    formatEuro,
    formatQuantity,
    formatNumber,
    formatDateDE,
    toISODate,
    addMonthsISO,
} from "../Statistics/format.js";

/**
 * Zeitraum-Voreinstellungen der Seite "Entgangener Umsatz" (Freigabe
 * 22.09.2026: "zum Beispiel nur das letzte Quartal oder das ganze letzte
 * Jahr oder frei wählbare Bereiche"). Bezugspunkt ist bewusst das echte
 * heutige Datum, nicht der jüngste Beleg wie in der Verkaufsstatistik -
 * der Cosmos-Rechenkern läuft nächtlich weiter, es gibt keinen
 * ERP-Ablösestichtag, der neuere Wochen künstlich leer ließe.
 */
export const ZEITRAUM_PRESETS = [
    {id: "letztes_quartal", label: "Letztes Quartal"},
    {id: "letztes_jahr", label: "Letztes Jahr"},
    {id: "laufendes_jahr", label: "Laufendes Jahr"},
    {id: "frei", label: "Frei wählbar"},
];

function heuteIso() {
    const heute = new Date();
    return toISODate(heute.getFullYear(), heute.getMonth() + 1, heute.getDate());
}

/** @returns {{von: string, bis: string}} */
export function berechnePresetZeitraum(preset) {
    const heute = new Date();
    const jahr = heute.getFullYear();

    switch (preset) {
        case "letztes_jahr":
            return {von: toISODate(jahr - 1, 1, 1), bis: toISODate(jahr - 1, 12, 31)};
        case "letztes_quartal": {
            const aktuellesQuartal = Math.floor(heute.getMonth() / 3);
            let quartal = aktuellesQuartal - 1;
            let quartalsJahr = jahr;
            if (quartal < 0) {
                quartal = 3;
                quartalsJahr -= 1;
            }
            const startMonat = quartal * 3;
            const letzterTag = new Date(quartalsJahr, startMonat + 3, 0).getDate();
            return {
                von: toISODate(quartalsJahr, startMonat + 1, 1),
                bis: toISODate(quartalsJahr, startMonat + 3, letzterTag),
            };
        }
        case "laufendes_jahr":
        default:
            return {von: toISODate(jahr, 1, 1), bis: heuteIso()};
    }
}

// Schreibweise deckungsgleich mit Components/Cosmos/format.js
// (PRODUKTLINIE_LABEL/produktlinieLabel) - eigene Kopie statt Import, weil
// resources/js/Components/Cosmos/ zum Dateibereich des parallel
// arbeitenden Agenten gehört (N9, Rückmeldung nach Sichtprüfung
// 22.09.2026: BURNER/PREMIUM/FLAME/MOLOTOW schreiben sich in Großbuchstaben,
// wie im Lieferplan und in der Lieferungen-Liste bereits umgesetzt).
export const PRODUKTLINIEN_LABEL = {
    PREMIUM: "PREMIUM",
    FLAME_ORANGE: "FLAME Orange",
    FLAME_BLUE: "FLAME Blue",
    BURNER: "BURNER",
};

export function produktlinieLabel(code) {
    return PRODUKTLINIEN_LABEL[code] || code || "Unbekannt";
}

/**
 * Deckungsgleich mit Components/Cosmos/format.js::formatFarbnummer (eigene
 * Kopie aus demselben Grund wie oben) - "#221" bzw. "#221-5" bei
 * gepflegter Unternummer, dreistellig mit führenden Nullen.
 */
export function formatFarbnummer(nummer, unter) {
    if (nummer === null || nummer === undefined || nummer === "") {
        return "";
    }
    const basis = String(nummer).padStart(3, "0");
    return `#${basis}${unter ? "-" + unter : ""}`;
}
